import { createStyles, Grid, makeStyles } from '@material-ui/core';
import HeaderMenu from '../../../Components/HeaderMenu';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
        },

    }),
);
function AdminHome() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid direction="row" >
                <Grid xs={12}>
                    <HeaderMenu />
                </Grid>
                
            </Grid>

        </div>
    )
}

export default AdminHome
